export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/sort-icon.24fee9e6.svg","height":10,"width":14,"blurWidth":0,"blurHeight":0};